<template>

    <!-- <b-form-group > -->
      <b-form-radio-group
            :options="options"
            text-field="name"
            :value="myValue"
            :checked = "value"
            @change="updateValue"
            @input="inputValue"
            :disabled="disabled"
            >
      </b-form-radio-group>
    <!-- </b-form-group> -->

</template>


<script>
export default {
    
    data(){
        return { myValue:null }
    },
    
    created:function(){
        this.myValue = this.value;
    },

     watch:{
        value:function(val){
            this.myValue = val
        }
    },
    
    props:{
        options:{},
        value:{},
        disabled:{
            type:Boolean,
            default:false
        }

    },
   
    computed:{
    },

    methods:{
         updateValue:function(val){
            this.myValue = val;
            
            this.$emit('change',val)
            this.$emit('input',val)
        },
         inputValue:function(val){
            this.myValue = val
            this.$emit('input',val)
        },

    }
}
</script>

<style>

</style>
